import { HorizontalAlignment, VerticalAlignment } from "@mcleod/core";
import { ImageName } from "@mcleod/images";
import { Image } from "../../components/image/Image";
import { ReportData } from "./ReportData";
import { ReportType } from "./ReportType";
import { ReportViewer } from "./ReportViewer";
import { ServerErrorPanel } from "../../../../common/src/ServerErrorPanel";
import { Tab } from "../../components/tabset/Tab";
import { TabProps } from "../../components/tabset/TabProps";
import { Tabset } from "../../components/tabset/Tabset";

export class ReportViewerTab extends Tab {
    private _reportData: ReportData;
    private reportViewer: ReportViewer;

    constructor(reportData: ReportData, props?: Partial<TabProps>) {
        super({ fillHeight: true, padding: 0 });
        this.setProps(props);
        this.reportViewer = new ReportViewer({ padding: 0 });
        this.add(this.reportViewer);
        this.reportData = reportData;
    }

    get reportData(): ReportData {
        return this._reportData;
    }

    set reportData(value: ReportData) {
        this._reportData = value;
        this.caption = this.reportData.reportName;
        if (this.reportData.serverError == null) {
            this.reportViewer.imageBytes = this.reportData.pdfBytes;
        }
        else {
            this.remove(this.reportViewer);
            this.align = HorizontalAlignment.CENTER;
            this.verticalAlign = VerticalAlignment.CENTER;
            this.add(new ServerErrorPanel(this.reportData.serverError));
        }
        this.syncId();
    }

    addImagesFromReportData() {
        if (this.reportData?.reportType === ReportType.ERROR) {
            this.imageName = ImageName.documentException;
        }
        if (this.reportData?.hasExceptions === true) {
            this.addHasExceptionsImage();
        }
    }

    private addHasExceptionsImage() {
        const imageHasExceptions = new Image({
            id: this.createInnerComponentId("imageHasExceptions"),
            name: ImageName.circleError,
            color: "error",
            marginLeft: 6
        });
        this.heading.add(imageHasExceptions);
    }

    get tabset(): Tabset {
        return super.tabset;
    }

    set tabset(value: Tabset) {
        super.tabset = value;
        this.syncId();
    }

    private syncId() {
        this.id = this.tabset?.createInnerComponentId(this.reportData.reportName) ?? "reportViewerTab";
    }
}
